module.exports = __webpack_public_path__ + "static/img/8.aaf6e80c.png";